const isEmpty = value => {
	return (
		value === null
		|| value === undefined
		|| ( typeof value === 'string' && value.trim() === '' )
		|| ( Array.isArray( value ) && value.length === 0 )
	);
};

const messageFor = ( rule, fallback ) => {
	const message = rule?.message ?? fallback;
	return message.startsWith( '^' ) ? message.slice( 1 ) : message;
};

export const isValidEmail = value => {
	return (
		typeof value === 'string'
		&& /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test( value )
	);
};

const validateFormValues = ( values = {}, constraints = {} ) => {
	const errors = {};

	Object.entries( constraints ).forEach( ([ field, rules ]) => {
		const value = values[ field ];
		const fieldErrors = [];

		if( rules.presence?.allowEmpty === false && isEmpty( value ) ) {
			fieldErrors.push( messageFor( rules.presence, 'This field is required' ) );
		}

		if( rules.email && !isEmpty( value ) && !isValidEmail( value ) ) {
			fieldErrors.push( messageFor( rules.email, 'Enter a valid email address' ) );
		}

		if( fieldErrors.length > 0 ) {
			errors[ field ] = fieldErrors;
		}
	});

	return Object.keys( errors ).length > 0 ? errors : undefined;
};

export default validateFormValues;
